import React from 'react';
import ReactDOM from 'react-dom';

import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import './index.scss';
import '@fortawesome/fontawesome-free/css/all.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import {configure} from "mobx";

// TODO: fix [MobX] Since strict-mode is enabled, changing (observed) observable values without using an action is not allowed.
configure({ enforceActions: "never",  });

for(let key in process.env){
   console.log(`${key}=${process.env[key]}`);
}

ReactDOM.render(
//   <React.StrictMode>
    <App />
//   </React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
